import {Component, effect, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule} from "@angular/common";
import {ProductService} from "@cybfed/core/services/marketplace/product.service";
import {TranslateModule} from "@ngx-translate/core";
import {InputComponent} from "@cybfed/ui-lib/forms/text-inputs/input/input.component";
import {StorageService} from "@cybfed/core/services/storage.service";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {appConstants} from "@cybfed/constants";
import {FileUploadService} from "@cybfed/core/services/file-upload.service";
import {DonationNotificationService} from "@cybfed/core/services/donation/donation-notification.service";
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";
import {LocalizationService} from "@cybfed/core/services/localization.service";
import {Ga4Service} from "@cybfed/core/helpers/ga4.service";
import {
    DonationWidgetButtonComponent
} from "@white-label/components/page-builder/widgets/donation-widget/donation-widget-button/donation-widget-button.component";
import {CrowdfundingService} from "@cybfed/core/services/donation/crowdfunding.service";
import {
    CrowdfundingRenderComponent
} from "@white-label/pages/admin-mode/widgets/crowdfunding-ad/crowdfunding-render/crowdfunding-render.component";

@Component({
    selector: 'app-donation-widget-item',
    templateUrl: './donation-widget-item.component.html',
    styles: `
      .letter{
        -webkit-background-clip:text !important;
        -webkit-text-fill-color: transparent !important;
      }`,
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        InputComponent,
        FormsModule,
        ReactiveFormsModule,
        CurrencyPipe,
        DonationWidgetButtonComponent,
        CrowdfundingRenderComponent
    ],
    providers: [
        ProductService,
        Ga4Service,
        DonationNotificationService,
        CrowdfundingService
    ]
})
export class DonationWidgetItemComponent implements OnInit, OnChanges {
    @Output() nextStepE: EventEmitter<any> = new EventEmitter();

    @Input() form!: FormGroup; // Reactive form group
    @Input() prices: number[] = [];
    @Input() stickersEnabled: boolean = false;

    setPrices: number[] = []

    customDonations: any = [];

    currentUser: any
    selectedSize: any = appConstants.IMAGESIZES[4];
    hasError: boolean = false;
    public donationMedia: any;
    private currencies = appConstants.Currencies
    selectCurrenciesOptions: any[] = [];
    public notifications: any = []
    public crowdfundings: any = []

    constructor(public mainStore: MainStoreService,
                private fileUploadService: FileUploadService,
                private ga4Service: Ga4Service,
                private _localizationService: LocalizationService,
                private _donationNotificationService: DonationNotificationService,
                private _crowdfundingService: CrowdfundingService,
    ) {
        effect(() => {
            if(this.mainStore.whiteLabel){
                this.getCustomDonationNotification()
            }
        });
    }

    ngOnChanges(changes: any): void {
        if(changes.prices) {
            this.setPrices = [...this.prices]
            this.form.controls['price'].patchValue(this.setPrices[0] || 50);
        }
    }

    ngOnInit() {
        this.currentUser = StorageService.getJsonItem(StorageService.statics.currentUser);
        for(let key in this.currencies){
            this.selectCurrenciesOptions.push({
                label: key,
                value: this.currencies[key]
            });
        }
        this.setPrices = [...this.prices]
        this.form.controls['price'].patchValue(this.setPrices[0] || 50)
        this.getDonationNotification()
        this.getCrowdfunding()
    }


    donate(type: string, item: any = null) {
        if(item){
            switch (type) {
                case "notification":
                    this.form.controls['price'].patchValue(item.fromAmount);
                    this.form.controls['metaData'].patchValue({...this.form.controls['metaData'].value, donationNotificationId: item._id});
                    break;
                case "crowdfunding":
                    this.form.controls['metaData'].patchValue({...this.form.controls['metaData'].value, crowdfundingId: item._id});
                    break;
                case "youtube_link":
                    this.form.controls['tip'].patchValue(item.price);
                    this.form.controls['metaData'].patchValue({...this.form.controls['metaData'].value, duration: item.duration});
                    break
            }
        }
        this.nextStepE.emit({form: this.form.value, type: type});
    }

    getImageSource(dataImg: string): void {
        this.onCreate(dataImg);
    }

    onCreate(dataImg: string | File): void {
            this.hasError = false;
            if(dataImg instanceof File){
                const formData = new FormData();
                formData.append('file', dataImg, dataImg.name);
                formData.append('title', 'donationFile');
                formData.append('class', this.selectedSize.class);
                this.fileUploadService.uploadFile(formData).subscribe((res: any) => {
                    if (!res.hasError) {
                        const {file} = res.data;
                        console.log(file)
                        this.donationMedia = file;
                        this.form.controls['media'].patchValue(file?.s3Url)
                        // this.showCropperBlock = false;
                    }
                });
            }else {
                const newData = {
                    file: dataImg,
                    title: 'this.fileTitle',
                    class: this.selectedSize.class,
                }
                this.fileUploadService.createFile(newData).subscribe((res: any) => {
                    if (!res.hasError) {
                        const {file} = res.data;
                        // this.imagesList.unshift(file);
                        // this.showLoader = false;
                        // this.cropper.showCropper = false;
                        // this.showCropperBlock = false;
                    }
                });
            }

    }

    protected readonly FormControl = FormControl;

    selectMoney(number: number) {
        this.form.controls['price'].setValue(number)
    }
    getDonationNotification(){
        this._donationNotificationService.getList({onlyEquals: true}).subscribe(response => {
            if (!response.hasError) {
                this.notifications = response.data.data
            }
        })
    }

    getCrowdfunding(){
        this._crowdfundingService.getList({status: 'active'}).subscribe(response => {
            if (!response.hasError) {
                this.crowdfundings = response.data.data
                console.log(this.crowdfundings)
            }
        })
    }

    getCustomDonationNotification(){
        let donationWidgetConfig = this.mainStore.whiteLabel.donationWidgetConfig;
        if (!donationWidgetConfig) {
            return
        }
        this.customDonations = [];
        if (donationWidgetConfig.allowYoutubeVideo) {
            this.customDonations.push({
                type: 'youtube_link',
                title: 'attach_youtube_video',
                trigger: 'youtube_video_link',
                styles: {
                    backgroundColor: '',
                    icon: '',
                    textColor: '',
                    backgroundImage: ''
                },
                price: donationWidgetConfig.youtubeVideoPlayingPrice,
                duration: donationWidgetConfig.youtubeVideoPlayingDuration,
            })
        }
        for(let item of donationWidgetConfig?.customDonationButtons || []){
            this.customDonations.push(item)
        }
    }

    changeCurrency(event: any) {
        let newCurrency = event.target.value;
        if (newCurrency == this.mainStore.whiteLabel.currency) {
            this.setPrices = [...this.prices]
        }else{
            this._localizationService.getCourse({from:  this.mainStore.whiteLabel.currency, to: newCurrency}).subscribe(response => {
                if (!response.hasError) {
                    if (response.data.course) {
                        this.setPrices =  this.prices.map((x) => x * response.data.course )
                    }
                }
            })
        }

    }

    protected readonly Math = Math;
    protected readonly Number = Number;
}
